import { fromJS } from 'immutable';
import * as coursewareTypes from 'pluginServices/constants/coursewareTypes';
import interactiveService from 'services/InteractiveService';
import { startPluginShared, removePluginInstance } from './index';
import { clearSubscriptionForScreen } from 'services/EventService';

// interactiveId -> info
export const activeInteractives = new Map();

export async function initializeInteractiveView(interactiveId, manifest, element, context) {
  if (activeInteractives.has(interactiveId)) {
    throw new Error(`interactiveId ${interactiveId} already initialized`);
  }
  activeInteractives.set(interactiveId, { element, context });

  const pluginId = manifest.id;
  const interactive = await interactiveService.getInteractive(interactiveId);
  const title = interactive?.config?.title;
  const name = interactive?.plugin?.name;

  let driver;
  try {
    driver = await startPluginShared(
      interactiveId, fromJS(manifest), element, context, pluginId, coursewareTypes.INTERACTIVE, title, name);
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }

  const entry = activeInteractives.get(interactiveId);
  entry.driver = driver;
}

export function removeInteractiveView(interactiveId) {
  if (!activeInteractives.has(interactiveId)) {
    return;
  }
  const entry = activeInteractives.get(interactiveId);
  const { element, driver } = entry;

  clearSubscriptionForScreen(interactiveId);
  removePluginInstance(interactiveId);

  while (element && element.firstChild) {
    element.removeChild(element.firstChild);
  }
  if (driver) {
    driver.cancelListenersAndSubscriptions();
  }
  activeInteractives.delete(interactiveId);
}
